export default function BlueprintBackground() {
  return (
    <div
      aria-hidden
      className="blueprint-bg pointer-events-none fixed inset-0 -z-10"
    />
  );
}
